import { defineMessages } from "react-intl";
const messages = defineMessages({
    communityPlanRequired: {
        id: "app.admin.addCommunity.communityPlan.text",
        defaultMessage: "Plan is required",
    },
    communityPlan: {
        id: "app.admin.addCommunity.plan.text",
        defaultMessage: "Plan",
    },
    communityName: {
        id: "app.admin.addCommunity.name.text",
        defaultMessage: "Community Name",
    },
    communityMetro: {
        id: "app.admin.addCommunity.metro.text",
        defaultMessage: "Metro Address",
    },
    communityPhone: {
        id: "app.admin.addCommunity.phone.text",
        defaultMessage: "Leads Phone Number",
    },
    communityBuildings: {
        id: "app.admin.addCommunity.address.text",
        defaultMessage: "Address",
    },
    communityOrganization: {
        id: "app.admin.addCommunity.organization.text",
        defaultMessage: "Organization Name",
    },
    communityLeadsEmail: {
        id: "app.admin.addCommunity.leadsEmail.text",
        defaultMessage: "Leads Email Address",
    },
    communityNameLength: {
        id: "app.admin.addCommunity.nameLength.text",
        defaultMessage: "Community's name should contain at least 1 character",
    },
    communityNameRequired: {
        id: "app.admin.addCommunity.nameRequired.text",
        defaultMessage: "Name is required",
    },
    communityNumberFormat: {
        id: "app.admin.addCommunity.numberFormat.text",
        defaultMessage: "Please enter mobile number in 999-999-9999 format",
    },
    communityNumberRequired: {
        id: "app.admin.addCommunity.numberRequired.text",
        defaultMessage: "Number is required",
    },
    communityOrganizationRequired: {
        id: "app.admin.addCommunity.organizationRequired.text",
        defaultMessage: "Organization is required",
    },
    communityEmailInvalid: {
        id: "app.admin.addCommunity.emailInvalid.text",
        defaultMessage: "Please enter valid email",
    },
    communityEmailRequired: {
        id: "app.admin.addCommunity.emailRequired.text",
        defaultMessage: "Email is required",
    },
    communityLeadsEmailRequired: {
        id: "app.admin.addCommunity.leadsEmailRequired.text",
        defaultMessage: "Leads email is required",
    },
    communityBuildingsRequired: {
        id: "app.admin.addCommunity.BuildingsRequired.text",
        defaultMessage: "Address required",
    },
    communitySuccessCreation: {
        id: "app.admin.addCommunity.success.text",
        defaultMessage: "Community created successfully",
    },
    communitySuccessUpdate: {
        id: "app.admin.updateCommunity.success.text",
        defaultMessage: "Community updated successfully",
    },
    communityCreate: {
        id: "app.admin.createCommunity.button.text",
        defaultMessage: "Create Community",
    },
    communityUpdate: {
        id: "app.admin.updateCommunity.button.text",
        defaultMessage: "Save",
    },
    communityUpdateDeactivation: {
        id: "app.admin.updateCommunity.deactivation.button.text",
        defaultMessage: "Deactivate Community",
    },
    communityTimeZone: {
        id: "app.admin.addCommunity.form.community.timeZone.text",
        defaultMessage: "Time Zone",
    },
    communityTimeZoneRequired: {
        id: "app.admin.addCommunity.form.community.timeZone.required.text",
        defaultMessage: "Time Zone Required",
    },
});
export default messages;
